import * as R from "ramda";

import { createHandlers } from "redux-mvc";

import { GROUP_BY, NAMESPACE } from "./constants";

const model = createHandlers({
  iniState: {
    tasks: [],
    dueDate: null,
    filters: GROUP_BY
  },
  reducers: {
    init: R.identity,
    followupForm: R.identity,
    selectFilters: (state, { payload }) => ({
      filters: R.map(
        filter => ({
          ...filter,
          selected: R.equals(filter.id, payload)
            ? R.not(filter.selected)
            : R.F()
        }),
        state.filters
      )
    })
  },
  namespace: NAMESPACE
});

const { getters, actions } = model;

export { getters, actions };

export default model;
